import { makeAutoObservable, runInAction } from 'mobx';
import { IShopReport, IShopReportParams } from 'src/@types/Choqorak/MainTables/Shop/ShopReport';
import agent from 'src/api/agent';
export default class ShopReportStore {
  openDialog = false;

  ShopReportRegistry = new Map<number, IShopReport>();

  editMode = false; //When click on edit button

  selectedShopReport: IShopReport | undefined = undefined;

  totalRecord: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  get ShopReportList() {
    return Array.from(this.ShopReportRegistry.values());
  }

  setShopReportList = (ShopReport: IShopReport) => {
    this.ShopReportRegistry.set(ShopReport.id!, ShopReport);
  };

  //Pagination
  loadShopReport = async (params: IShopReportParams) => {
    // this.ShopReportRegistry.clear();
    try {
      const result = await agent.ShopReport.getList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed = result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setShopReportList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Search
  ShopReportSearch = async (params: IShopReportParams) => {
    //this.ShopReportRegistry.clear();
    this.loadShopReport(params);
  };

  getShopReportFromRegistry = (id: number) => {
    let ShopReport = this.ShopReportRegistry.get(id);
    if (ShopReport) {
      this.editMode = true;
      this.selectedShopReport = ShopReport;
    }
  };

  clearSelectedShopReport = () => {
    this.editMode = false;
    this.selectedShopReport = undefined;
  };

  deleteShopReport = async (id: number, remark?: string) => {
    try {
      await agent.ShopReport.delete(id, remark!);
      runInAction(() => {
        this.ShopReportRegistry.delete(id);
        this.totalRecord--;
        this.setOpenCloseDialog();
      });
    } catch (error) {
      console.log(error);
    }
  };

  setOpenCloseDialog = () => (this.openDialog = !this.openDialog);

  createShopReport = async (ShopReport: IShopReport) => {
    try {
      await agent.ShopReport.create(ShopReport);
      runInAction(() => {
        this.loadShopReport({ pageIndex: 0, pageSize: 5 });
        this.clearSelectedShopReport();
      });
    } catch (error) {
      console.log(error);
    }
  };

  updateShopReport = async (ShopReport: IShopReport) => {
    try {
      await agent.ShopReport.update(ShopReport);

      runInAction(() => {
        this.loadShopReport({ pageIndex: 0, pageSize: 5 });
        this.ShopReportRegistry.delete(ShopReport.id!);
        this.ShopReportRegistry.set(ShopReport.id!, ShopReport);
        this.clearSelectedShopReport();
      });
    } catch (error) {
      console.log(error);
    }
  };
}
